import { AxiosResponse } from 'axios'
import { CreatePaymentIntentRequest, PaymentIntentResponse } from './generated/models'
import apiClient from './apiClient'

const generateIdempotencyKey = () => {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
}

export const paymentIntentApi = {
  createPaymentIntent: async (request: CreatePaymentIntentRequest): Promise<PaymentIntentResponse> => {
    const idempotencyKey = generateIdempotencyKey()

    const response: AxiosResponse<PaymentIntentResponse> = await apiClient.post('/api/v1/payment-intents', request, {
      headers: {
        'Idempotency-Key': idempotencyKey,
      },
    })
    return response.data
  },
}
